module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_browss.df2c9c0c.png";